'use client';

import { Suspense } from 'react';
import SharedLayout from '../../components/SharedLayout';
import PolicyPageLayout from '../components/PolicyPageLayout';

// Content component that will be wrapped in Suspense
function PrecursoresQuimicosContent() {
  return (
    <SharedLayout>
      <div className="container mx-auto px-4 py-8">
        <PolicyPageLayout
          title="Política de Precursores Químicos"
          lastUpdated="15 de Enero de 2023"
        >
          <div className="space-y-8">
            {/* Sección Política de Precursores Químicos */}
            <section>
              <h2 className="text-2xl font-bold mb-4 text-blue-800">
                POLÍTICA DE PRECURSORES QUÍMICOS
              </h2>
              
              <p className="mb-4">
                Droquimar ha definido una Política de Precursores Químicos basada en la cooperación 
                Público-Privada para combatir el problema de las drogas. La responsabilidad social 
                del empresariado hoy debe ampliarse a fin de proyectarse a otras áreas como el cuidado 
                del medio ambiente o la lucha contra el uso abusivo de sustancias psicoactivas, 
                procurando, a través de la participación y el compromiso ciudadano, aportar a la 
                solución de estas problemáticas que nos atraviesan a todos como sociedad.
              </p>
              
              <p className="mb-6">
                Droquimar adhiere al principio de la responsabilidad compartida, que entraña el 
                compromiso mutuo de perseguir objetivos comunes y la determinación de emprender 
                una acción conjunta. Es así que declara:
              </p>
              
              <ul className="list-disc ml-6 space-y-4">
                <li>
                  La colaboración con todas las instancias de gobierno, la sociedad civil, las 
                  comunidades locales y el sector privado para actuar conforme a un acuerdo que 
                  garantice la salud y el bienestar de la población.
                </li>
                
                <li>
                  La inscripción en el Registro Nacional de Precursores Químicos cumpliendo con 
                  todas las normativas, obligaciones, certificaciones, inscripciones y presentaciones 
                  de informes que dispone el organismo.
                </li>
                
                <li>
                  La participación en la Cámara Argentina de Productos Químicos que a través del 
                  Consejo Consultivo de Precursores Químicos del Ministerio de Seguridad cooperará 
                  en el control efectivo y eficiente de los precursores químicos.
                </li>
                
                <li>
                  El compromiso de difundir información a clientes inscriptos en el Registro Nacional 
                  de Precursores Químicos sobre las distintas normativas que regulan las operaciones 
                  de precursores químicos con el fin de colaborar en su conocimiento y aplicación.
                </li>
                
                <li>
                  La acción proactiva de fiscalización de la operatoria interna, respetando las 
                  cuestiones atinentes al uso legal de dichas sustancias químicas en las distintas 
                  etapas de producción, comercio, almacenamiento, fabricación y transporte, para 
                  evitar el desvío de precursores químicos hacia actividades ilícitas.
                </li>
                
                <li>
                  La capacitación y concientización del personal sobre la problemática de adicciones, 
                  y el tratamiento responsable de precursores químicos; como así también, las 
                  consecuencias del incumplimiento de las normativas vigentes.
                </li>
              </ul>
            </section>

            {/* Sección Política sobre Tabaco, Alcohol y Drogas */}
            <section>
              <h2 className="text-2xl font-bold mb-4 text-blue-800">
                POLÍTICA SOBRE TABACO, ALCOHOL Y DROGAS EN EL TRABAJO
              </h2>
              
              <p className="mb-4">
                Droquimar S.R.L. ha definido y establecido una política sobre tabaco, alcohol y 
                drogas en el trabajo, para prevenir, mejorar, conservar y preservar el bienestar 
                de todos sus colaboradores, con el objetivo de mejorar la calidad de vida y 
                garantizar un adecuado desempeño de las actividades en la empresa.
              </p>
              
              <p className="mb-4">
                La compañía es consciente que el alcoholismo, la drogadicción y el abuso de 
                sustancias alucinógenas y enervantes tienen efectos adversos en la capacidad de 
                desempeño, representan un riesgo y afectan considerablemente la salud, seguridad, 
                eficiencia y productividad del personal en el trabajo.
              </p>
              
              <p className="mb-6">
                Droquimar S.R.L. aspira a desarrollar sus actividades libres de todo riesgo o 
                peligro que afecte la salud y la vida de sus trabajadores o de quienes deban 
                concurrir a sus instalaciones. Por lo tanto, declara:
              </p>
              
              <ul className="list-disc ml-6 space-y-4">
                <li>
                  La prohibición de fumar en el interior de las instalaciones de la empresa y de 
                  sus clientes, así como en el interior de los vehículos de servicio o de transporte.
                </li>
                
                <li>
                  La prohibición de presentarse a trabajar bajo el efecto del alcohol, drogas y/o 
                  sustancias alucinógenas y enervantes o que creen dependencia.
                </li>
                
                <li>
                  La prohibición de utilización indebida de medicamentos formulados, posesión, 
                  distribución y venta de drogas no recetadas o de sustancias alucinógenas y 
                  enervantes, y la posesión y uso de bebidas alcohólicas en las instalaciones 
                  de la empresa.
                </li>
                
                <li>
                  Se considera atentatoria a la salud e integridad física de las personas y bienes 
                  de la empresa, realizar labores durante o después del consumo de sustancias 
                  psicoactivas, aun cuando éstas sean terapéuticas. El consumidor de sustancias 
                  psicoactivas de carácter terapéuticas, debidamente comprobado, deberá informar 
                  de esta circunstancia a su Jefe Directo.
                </li>
                
                <li>
                  La empresa se reserva el derecho de verificar, a través de los medios que permita 
                  la ley y los reglamentos, la circunstancia de encontrarse el trabajador en alguna 
                  de las situaciones descritas anteriormente, en cuyo caso adoptará las medidas que 
                  el caso amerite.
                </li>
                
                <li>
                  En las reuniones de trabajo y/o coordinación que se realicen en recintos de la 
                  empresa y en las cuales de deba almorzar o cenar, no se podrá contemplar en ningún 
                  caso el consumo de alcohol.
                </li>
                
                <li>
                  El consumo de alcohol y/o drogas en la vida privada del trabajador de la empresa, 
                  que trascienda públicamente en riñas, accidentes o violencia intrafamiliar, será 
                  considerado como un acto reprobable, contrario a la presente Política.
                </li>
              </ul>
              
              <p className="mt-6">
                Droquimar se compromete a dar cumplimiento a esta política y espera por su parte, 
                la colaboración de todos los empleados, participando activamente en los programas 
                de sensibilización y capacitación.
              </p>
            </section>
          </div>
          
          <div className="mt-8 text-right">
            <p className="font-bold">La Gerencia</p>
          </div>
        </PolicyPageLayout>
      </div>
    </SharedLayout>
  );
}

// Fallback component for Suspense
function PrecursoresQuimicosFallback() {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-4xl mx-auto bg-white p-8 rounded-lg shadow-lg">
        <div className="animate-pulse">
          <div className="h-8 bg-gray-200 rounded w-1/2 mb-4"></div>
          <div className="h-4 bg-gray-200 rounded w-1/4 mb-8"></div>
          <div className="h-4 bg-gray-200 rounded w-full mb-4"></div>
          <div className="h-4 bg-gray-200 rounded w-full mb-4"></div>
          <div className="h-4 bg-gray-200 rounded w-3/4 mb-8"></div>
          
          <div className="h-6 bg-gray-200 rounded w-1/2 mb-4"></div>
          <div className="h-4 bg-gray-200 rounded w-full mb-4"></div>
          <div className="h-4 bg-gray-200 rounded w-full mb-4"></div>
          <div className="h-4 bg-gray-200 rounded w-5/6 mb-8"></div>
          
          <div className="h-6 bg-gray-200 rounded w-2/3 mb-4"></div>
          <div className="h-4 bg-gray-200 rounded w-full mb-4"></div>
          <div className="h-4 bg-gray-200 rounded w-full mb-4"></div>
          <div className="h-4 bg-gray-200 rounded w-4/5 mb-8"></div>
        </div>
      </div>
    </div>
  );
}

// Main component that wraps the content in Suspense
export default function PrecursoresQuimicosPage() {
  return (
    <Suspense fallback={<PrecursoresQuimicosFallback />}>
      <PrecursoresQuimicosContent />
    </Suspense>
  );
}